module.exports = "<section class=\"video\">\r\n    <div class=\"video\">\r\n        <iframe [src]=\"safeUrl\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\r\n    </div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/video/video.component.html
// module id = ../../../../../src/app/video/video.component.html
// module chunks = main